<template>
    <section class="home-photos">
      <div>
        <h2 class="f2 text-bold">{{molang('home.welcomeHomeIsCloser')}} </h2>
        <div class="home-photos-desc f4">{{ molang('home.withCustomizableSearch') }}</div>
      </div>
      <ul class="fixed fixed-max-sm">
        <li>
          <div>
            <h3>{{ molang('home.localLicensedVetted') }}</h3>
            <p>{{ molang('home.yourMovotoAgentWillHelp') }}</p>
            <a :href="glb.appUrl + 'agents/'" class="btn regular" :aria-label="molang('home.getConnected') + ' - ' + molang('home.localLicensedVetted')">{{ molang('home.getConnected') }}</a>
          </div>
          <img :src="glb.cdnUrl + 'images/desktop/home/home-photo-1.webp'" :alt="molang('home.localLicensedVetted')" width="1920" height="957" loading="lazy">
        </li>
        <li>
          <div>
              <h3>{{ molang('home.findOutWhatYouCanAfford') }}</h3>
              <p>{{molang('home.understandHowMuchYou')}}</p>
              <a :href="glb.appUrl + 'mortgages/calculator/'" class="btn regular" :aria-label="molang('home.calculateMortgage') + ' - ' + molang('home.findOutWhatYouCanAfford')">{{ molang('home.calculateMortgage') }}</a>
          </div>
            <img :src="glb.cdnUrl + 'images/desktop/home/home-photo-2.webp'" :alt="molang('home.findOutWhatYouCanAfford')" width="1920" height="1076" loading="lazy">
        </li>
        <li>
            <div>
                <h3>{{ molang('home.beTheFirstToKnow') }}</h3>
                <p>{{ molang('home.customizeYourSearchAround') }}</p>
                <button type="button" @click="goToSavedSearch" class="btn regular" >{{ molang('home.getNotified') }}</button>
            </div>
            <img :src="glb.cdnUrl + 'images/desktop/home/home-photo-3.webp'" :alt="molang('home.beTheFirstToKnow')" width="1920" height="1012" loading="lazy">
        </li>
      </ul>
    </section>

</template>
<script src="./home-photos.js"></script>
<style lang="scss">
@use "./home-photos.scss" as *;
</style>